export const PRICE_PER_MEETING_OPTIONS = [
  {},
  { pricePerMeetingMax: 10 },
  { pricePerMeetingMax: 20 },
  { pricePerMeetingMax: 30 },
  { pricePerMeetingMax: 40 },
  { pricePerMeetingMin: 40 },
];
